// extracted by mini-css-extract-plugin
module.exports = {"brand":"BrandValues_brand__A1twk","container":"BrandValues_container__4jE2p","card":"BrandValues_card__83lsT","title":"BrandValues_title__iag_Q","text":"BrandValues_text__ngBw7"};